// extracted by mini-css-extract-plugin
export var container = "_5x-1";
export var editor = "_5x-2";
export var resizable = "_5x-3";
export var wrapper = "_5x-0";